module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAI5JREFUSIntkrENgzAUBc+IDTJCBmAEezSPwhh0hBFokTICMzwKQIqIUSzLFI64zv/Ld82H0jEAkjxgM7sHY4yvt4cFXOYAANUV0jtQSKDtJtpuSpp9Up8txvecPIsKNM9H8uwLSb3y08NfX9Ed2NnPdAjs3MmfV6Q75FyR5AJn5yPFvzkE8omPkUvExbEAI0ieFuofTMIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/3_active.png
// module id = a8TV
// module chunks = 171